import { render, staticRenderFns } from "./mutasiLokasi.vue?vue&type=template&id=b315149e"
import script from "./mutasiLokasi.vue?vue&type=script&lang=js"
export * from "./mutasiLokasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports